// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__AyZoo","label":"index_label__ePp+d","label-text":"index_label-text__-Wbtn","value":"index_value__MoxYR"};